import axios from 'axios';

// Public student QR landing page — reuses the existing global axios instance
// (baseURL + Bearer token from main.js), same convention as blogService.js.
// Each section is its own request so the page can prioritize the profile
// header first and load attendance/payments/exams independently (and so
// changing the month/year only refetches that one section).
export const qrService = {
  async resolve(token) {
    const res = await axios.get(`/web/qr/${token}`);
    return res.data; // { status, data | message }
  },

  async attendance(token, month) {
    const res = await axios.get(`/web/qr/${token}/attendance`, { params: month ? { month } : {} });
    return res.data; // { status, data: { month, records, summary, available_months } }
  },

  async payments(token) {
    const res = await axios.get(`/web/qr/${token}/payments`);
    return res.data; // { status, data: { items, summary } }
  },

  async exams(token, academicYearId) {
    const res = await axios.get(`/web/qr/${token}/exams`, { params: academicYearId ? { academic_year_id: academicYearId } : {} });
    return res.data; // { status, data: { academic_year_id, available_years, exams } }
  },

  async followUps(token) {
    const res = await axios.get(`/web/qr/${token}/follow-ups`);
    return res.data; // { status, data: { follow_ups, rating_summary } }
  },
};
